import styled from 'styled-components';
import DateField from '../../../../UI/Field/Date/DateField';

export const DateSuspensaoUsuario = styled(DateField)`
  width: 100%;
`;
